import {
  ActionIcon,
  Anchor,
  Avatar,
  AvatarGroup,
  Badge,
  Box,
  Button,
  Checkbox,
  // createStyles,
  Divider,
  Group,
  Menu, ScrollArea, Skeleton,
  Table,
  Text, Tooltip,
  useMantineTheme
} from "@mantine/core";

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { connect, useDispatch } from "react-redux";
import {
  FlagToggle,
  FormInputWrapper, StarRating
} from "../../../../core/components";
import { fetchApprovalStyleCaptures, getApprovalStyleCapturesSuccess, getStyleSuccess, setDisplayPrefs } from "modules/Wip/wipSlice";
import { setPreviousRoute } from "app/appSlice";
// import { useFilters, useGlobalFilter, usePagination, useSortBy, useTable } from 'react-table';
import {
  IconCamera,
  IconChecklist,
  IconClearAll,
  IconColorSwatch,
  IconDots,
  IconDownload, IconShirt,
  IconSubtask,
  IconUserCheck
} from "@tabler/icons-react";
import Moment from "react-moment";
import { ListViewOption } from "core/components/listToggle/listToggleControl";
// import SessionMediaGridLayout from './SessionMediaGridLayout';
import { CaptureEventType } from "core/components/capture/CaptureThumb";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { DataFormats } from "utils/constants";
import * as utils from "utils/helper";

import { logger } from "utils/logger";
import { MediaFilterModel } from "core/models";
// import { useExpanded } from 'react-table';
import { openModal } from "@mantine/modals";
import { useAbortController } from "core/hooks/useAbortableController";
import { createStyles } from "@mantine/emotion";
import {
  createColumnHelper,
  flexRender,
  getCoreRowModel,
  getExpandedRowModel,
  getFilteredRowModel,
  getGroupedRowModel,
  getPaginationRowModel,
  getSortedRowModel,
  useReactTable,
} from "@tanstack/react-table";
import Th from "core/components/table/Thead";
import { CountDisplay } from "core/components/countDisplay/CountDisplay";
import { SampleEventType, SampleStatusTypes } from "core/models/SampleModel";
import moment from "moment";
import StyleMediaGridLayout from "./StyleMediaGridLayout";


var _ = require("lodash");

const useStyles = createStyles((theme, _params, getRef) => ({}));

const IndeterminateCheckbox = React.forwardRef(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef = ref || defaultRef;

    React.useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
      logger.log(indeterminate);
    }, [resolvedRef, indeterminate]);

    return (
      <>
        <Checkbox
          type="checkbox"
          ref={resolvedRef}
          {...rest}
          indeterminate={indeterminate}
        />
        {indeterminate.toString()}
      </>
    );
  }
);

const StyleMediaList = ({
  user,
  style,
  success,
  error,
  form,
  setPreviousRoute,
  onMediaAction,
  displayPrefs,
  styleMediaFilter,
  setStyleMediaFilter,
  displaySettings,
  selectedItems,
  setSelectedItems,
  onCaptureChange,
}) => {
  const [data, setData] = useState([]);
  // const [styleMediaFilter, setStyleMediaFilter] = useState(new MediaFilterModel());
  const [selectedGroups, setSelectedGroups] = useState([]);
  // const [selectedItems, setSelectedItems] = useState([]);
  const [selectedItem, setSelectedItem] = useState([]);
  const [filterOpen, setFilterOpen] = useState(false);
  const [filterCount, setFilterCount] = useState(0);
  const [filterItems] = useState(styleMediaFilter);

  const [imageModalOpen, setImageModalOpen] = useState(false);

  const [listView, setListView] = useState(displayPrefs.mediaDisplayType);
  // const [hasFetched, setHasFetched] = useState(false);
  const hasFetchedRef = useRef(null);

  const [showLoading, setShowLoading] = useState(true);

  const [styleCodes, setStyleCodes] = useState([]);

  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const { classes, cx } = useStyles();

  const [sessionsPageIndex, setSessionsPageIndex] = useState(0); // keep this state so we can use it when data is refreshed
  const [loading, setLoading] = useState(true);
  const [scrolled, setScrolled] = useState(false);

  const [sorting, setSorting] = useState([{ id: "tags", desc: true }]);

  const abortController = useAbortController();

  const [{ pageIndex, pageSize }, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });

  const pagination = useMemo(
    () => ({
      pageIndex,
      pageSize,
    }),
    [pageIndex, pageSize]
  );
  const [grouping, setGrouping] = useState([]);

  const [columnPinning, setColumnPinning] = useState({
    // left: ["department"],
    // right: ["action"],
  });


const columnHelper = createColumnHelper();

const columns = useMemo(() => [
  columnHelper.accessor("styleNumber", {
    header: "Style Number",
    cell: (info) => info.getValue(),
    size: 180,
  }),

  columnHelper.accessor("name", {
    header: "Name",
    cell: (info) => info.getValue(),
    size: 300,
  }),

  columnHelper.accessor("seasonCode", {
    header: "Event",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("sessionCode", {
    header: "Session",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("dept", {
    header: "Department",
    cell: (info) => info.getValue(),
    size: 180,
  }),
  columnHelper.accessor("otbDate", {
    header: utils.getClientLabel(user.clientCode, 'otbDate'),
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor("completed", {
    header: "Completed",
    cell: (info) => info.getValue(),
  }),

  columnHelper.accessor("distributionDate", {
    header: "Distribution Date",
    cell: (info) => info.getValue(),
    size: 200,
  }),
], [user.clientCode]);


  const table = useReactTable({
    data,
    columns,
    pageCount: Math.ceil(data.length / pagination.pageSize) ?? -1,
    autoResetExpanded: false,
    state: {
      columnPinning,
      sorting,
      grouping,
      pagination,
    },
    onColumnPinningChange: setColumnPinning,
    onSortingChange: setSorting,
    // onGroupingChange: setGrouping,
    getExpandedRowModel: getExpandedRowModel(),
    getGroupedRowModel: getGroupedRowModel(),
    getCoreRowModel: getCoreRowModel(),
    getPaginationRowModel: getPaginationRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
    onPaginationChange: setPagination,
    manualPagination: false,
    debugTable: false,
  });

  function changeSorting(columnName, isDescending) {
    logger.log(columnName, isDescending);
    const newSorting = [{ id: columnName, desc: isDescending }];
    setSorting(newSorting);
  }

  /**
   * Effect to handle the success state change
   */
  useEffect(() => {
    if (success) {
      logger.log(success, " SUCCESS");
      switch (success.type) {
        // if we have fetched the session media set the state.
        case getStyleSuccess.toString(): {
            // setHasFetched(true);
            hasFetchedRef.current = true;

            dispatch(fetchApprovalStyleCaptures({ sessionCode: params.sessionId, styleNumber: params.styleNumber }));

            // setShowLoading(false);
            break;
        }
        case getApprovalStyleCapturesSuccess.toString(): {
            setShowLoading(false);
            break;
        }
        default: {
        }
      }
    }
  }, [success]);

  /**
   * Effect to handle the filter changes. When this happens we refilter
   * the session media.
   */
  useEffect(() => {
    const count = utils.getMediaFilterCount(styleMediaFilter);
    setFilterCount(count);
    filterMedia();
    setSessionsPageIndex(0);
  }, [styleMediaFilter]);

  /**
   * Method to filter the session media
   */
  const filterMedia = useCallback(() => {
    logger.log("FILTERING MEDIA", style);

    if (style && style.assets) {
      var newData = utils.filterMedia(style.assets, styleMediaFilter);

      // add the photocode to the data.
      // newData = newData.map((tmpCapture) => {
      //     var item = { ...tmpCapture };
      //     if (item.type && item.type === 'group') {
      //         const style = session.samples.find((val) => val.stylenumber === item.id);
      //         if (style && style.photoCode) {
      //             item.photoCode = style.photoCode;
      //             item.styleName = style.name;
      //         }
      //         if (style && style.name) {
      //             item.styleName = style.name;
      //         }
      //     } else {
      //         const style = session.samples.find((val) => val.stylenumber === item.styles);
      //         if (style && style.photoCode) {
      //             item.photoCode = style.photoCode;
      //         }
      //         if (style && style.name) {
      //             item.styleName = style.name;
      //         }
      //     }

      //     return item;
      // });

      setData([...newData]);
    }
  }, [styleMediaFilter, setData, style]);

  /**
   * Debounce fetch so it isn't called multiple times.
   */
  const fetchMedia = useCallback(
    _.debounce(function (criteria, signal) {
      logger.log(criteria);
      // dispatch(fetchSessionMedia(criteria, signal));
    }, 1000),
    []
  );

  /**
   * Effect to fetch media when the session changes
   * We also need to check to see if the media doesn't already exist otherwise we don't
   * need to fetch.
   */
  const params = useParams();
  const { id } = params;
  useEffect(() => {
    // const getClientId = () => {
    //     return session.sessionId.split('-')[0];
    // };
    // // only fetch if media hasn't been fetched.
    // // we also fetch if the session has changed and no media has been assigned.
    // // this happens when a route changes and we select a new session
    // if ((session && session.sessionId && !hasFetchedRef.current && !session.media) || session && hasFetchedRef.current && !session.media) {
    //     var criteria = {};

    //     logger.log('search submit');

    //     criteria.sessionId = session.sessionId;
    //     criteria.client = session.client ? session.client : getClientId();

    //     fetchMedia(criteria,abortController.current.signal);
    //     // setHasFetched(true);
    //     hasFetchedRef.current = true;

    //     // Check if aborted before continuing
    //     // if (signal.aborted) return;

    // }

    if (style && style.assets) {
      logger.log(style.assets);

      if(style.styleNumber === id){
        setShowLoading(false)
      }
      // setHasFetched(true);
      filterMedia();
    }
  }, [style]);

  /**
   * Handler for the Capture menu events.
   * @param {*} e
   * @param {*} data
   * @param {*} items
   */
  const onMenuItemClick = (e, data, items) => {
    logger.log(e);
    var captures = [];
    // switch (e) {
    //     case CaptureEventType.DOWNLOAD: {
    //         // find all the items
    //         const arr = items.map((val) => {
    //             const item = session.media.find((session) => val.id === session.id);
    //             if (item) return item;
    //         });
    //         const extension = data.type && data.type === 'eipURL' ? 'eip' : 'png';
    //         // handleZipDownload(arr, 'originalFilename', session.sessionId, data.type, extension);
    //         break;
    //     }
    //     case CaptureEventType.RATING_CHANGE:
    //     case CaptureEventType.STATUS_CHANGE: {
    //         captures = items.map((val) => {
    //             return session.media.find((obj) => obj.id === val.id);
    //         });

    //         onCaptureChange(e, data, captures);
    //         break;
    //     }
    //     case CaptureEventType.BATCH_CREATE_TASK:
    //     case CaptureEventType.APPLY_STYLE_INFO:
    //     case CaptureEventType.CREATE_TASK: {
    //         captures = items.map((val) => {
    //             return session.media.find((obj) => obj.id === val.id);
    //         });

    //         onMediaAction(e, data, captures);
    //         break;
    //     }
    //     case CaptureEventType.TAG_TALENT: {
    //         setShowTagTalent(true);
    //         break;
    //     }
    //     default: {
    //         break;
    //     }
    // }
  };

  // Set the stylecodes
  // useEffect(() => {
  //     if (session && session.samples) {
  //         const arr = session.samples.map((val) => {
  //             return {
  //                 // label: `${val.stylenumber} - ${val.name}`,
  //                 label: `${val.stylenumber} / ${val.photoCode}`,
  //                 value: val.stylenumber,
  //             };
  //         });
  //         setStyleCodes([...arr]);
  //     }
  // }, [session?.samples?.length]);

  /**
   * Handles the list toggle display
   * @param {*} val
   */
  const listToggleHandler = (val) => {
    // navigate({ search: `?tab=media&displayType=${val}` });
    // setListView(val);
    const prefs = { ...displayPrefs, mediaDisplayType: val };
    dispatch(setDisplayPrefs(prefs));
  };

  useEffect(() => {
    if (
      displayPrefs &&
      displayPrefs.mediaDisplayType &&
      displayPrefs.mediaDisplayType !== listView
    ) {
      setListView(displayPrefs.mediaDisplayType);
    }
  }, [displayPrefs]);

  /**
   * The select all menu component part of the checkbox dropdown
   */
  const selectAllMenu = (
    <div>
      <Button
        variant="default"
        leftIcon={<IconDownload size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.DOWNLOAD,
            { data: null, type: "previewHi" },
            selectedItems
          )
        }
      >
        Download Hi-res
      </Button>

      <Button
        variant="default"
        leftIcon={<IconDownload size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.DOWNLOAD,
            { data: null, type: "eipURL" },
            selectedItems
          )
        }
      >
        Download EIP
      </Button>

      <Button
        variant="default"
        leftIcon={<IconClearAll size={14} />}
        onClick={(e) => setSelectedItems([])}
      >
        Deselect All
      </Button>
      {/* <Button variant='default' leftIcon={<IconSubtask size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.CREATE_TASK, { data: null }, selectedItems)}>
                Create Task
            </Button> */}
      <Button
        variant="default"
        leftIcon={<IconColorSwatch size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.APPLY_STYLE_INFO,
            { data: null },
            selectedItems
          )
        }
      >
        Apply Styles
      </Button>

      <Button
        variant="default"
        leftIcon={<IconUserCheck size={14} />}
        onClick={(e) =>
          onMenuItemClick(
            CaptureEventType.TAG_TALENT,
            { data: null },
            selectedItems
          )
        }
      >
        Tag Talent
      </Button>

      {/* <Button variant='default' leftIcon={<IconArchive size={14} />} onClick={(e) => onMenuItemClick(CaptureEventType.ARCHIVE, { data: null }, selectedItems)}>
                Archive Assets
            </Button> */}

      {styleMediaFilter?.groupBy === "styles" ? (
        <Button
          variant="default"
          leftIcon={<IconChecklist size={14} />}
          onClick={(e) =>
            onMenuItemClick(
              CaptureEventType.BATCH_CREATE_TASK,
              { data: null },
              selectedItems
            )
          }
        >
          Batch Create Tasks
        </Button>
      ) : null}

      <Divider mt={"sm"} />
      {/* <Group>
      <Title order={6} color={'dimmed'}>Rating</Title>
      <Divider />
    </Group> */}
      <Group px={"xs"}>
        <FormInputWrapper
          label="Rate"
          id="input-rating"
          labelWidth={60}
          style={{ marginTop: 12, marginBottom: 0 }}
        >
          <StarRating
            size={"sm"}
            onChange={(val) =>
              onMenuItemClick(
                CaptureEventType.RATING_CHANGE,
                { data: val },
                selectedItems
              )
            }
          />
        </FormInputWrapper>
      </Group>

      <Group px={"xs"}>
        <FormInputWrapper
          label="Flag"
          id="input-rating"
          labelWidth={60}
          style={{ marginTop: 12, marginBottom: 0 }}
        >
          <FlagToggle
            size={"sm"}
            onChange={(val) =>
              onMenuItemClick(
                CaptureEventType.STATUS_CHANGE,
                { data: val },
                selectedItems
              )
            }
          />
        </FormInputWrapper>
      </Group>
    </div>
  );

  const onItemClick = (val) => {
    logger.log("ON ITEM CLICK");
    showImageModal(val);
  };

  /**
   * Handler for when a capture is selected.
   * @param {*} item
   * @param {*} selected
   */
  const onItemSelected = (e, item, selected) => {
    var items = [...selectedItems];

    // const pageItems = page.map((val) => {
    //     return { ...val.original };
    // });

    // if (item.type && item.type === 'group') {
    //     // select all the sub items.
    //     let subItems = [...item.subRows];
    //     if (selected) {
    //         subItems.forEach((val) => {
    //             selectItems(e, val, selected, pageItems, items);
    //         });
    //     } else {
    //         items = _.differenceBy(items, subItems, 'id');
    //     }

    //     // if(selected){
    //     //     items = items.concat(subItems);
    //     // }else{
    //     //     items = items.filter(val => !subItems.find(item => item.id === val.id))
    //     // }
    // } else {
    //     // call general helper to select items
    //     selectItems(e, item, selected, pageItems, items);
    // }

    setSelectedItems(items);
    //dispatch(selectTasks(items));
    //selectTask(items);
  };

  const onSelectAll = () => {
    // table.getToggleAllPageRowsSelectedHandler()
    // if there are items selected remove them
    if (selectedItems.length) {
      setSelectedItems([]);
      // toggleAllRowsSelected(false);
      //setSelectedItems([])
      //dispatch(selectTasks([]));
    } else {
      var elems = [...data];

      // if there is a group by we need to grab the subrows
      if (styleMediaFilter.groupBy && styleMediaFilter.groupBy.length) {
        elems = _.flatMap(data, "subRows");
      }

      setSelectedItems([...elems]);
      // toggleAllRowsSelected(true);
      //setSelectedItems([...elements])
      //dispatch(selectTasks([...data]));
    }
  };

  const onGroupSelect = (e, item, selected) => {
    var items = [...selectedGroups];

    // const pageItems = page.map((val) => {
    //     return { ...val.original };
    // });

    // if (item.type && item.type === 'group') {
    //     // select all the sub items.
    //     let subItems = [...item.subRows];
    //     if (selected) {
    //         selectItems(e, item, selected, pageItems, items);
    //         // subItems.forEach((val) => {
    //         //     selectItems(e, val, selected, pageItems, items);
    //         // });
    //     } else {
    //         // items = _.differenceBy(items, subItems, 'id');
    //         items = items.filter((val) => val.id !== item.id);
    //     }

    //     // if(selected){
    //     //     items = items.concat(subItems);
    //     // }else{
    //     //     items = items.filter(val => !subItems.find(item => item.id === val.id))
    //     // }
    // } else {
    //     // call general helper to select items
    //     selectItems(e, item, selected, pageItems, items);
    // }

    setSelectedGroups(items);
  };
  /**
   * Handler for the Capture event types
   * @param {*} type
   * @param {*} val
   * @param {*} originalEvent
   */
  const onImageEvent = (type, val, originalEvent, rows) => {
    logger.log(type, val);
    var items;
    
    onMediaAction(type, val, originalEvent, rows);

    function openTaskModal(task) {
      // dispatch(selectTask(task));

      openModal({
        title: "Quick Create Task",
        size: "xl",
        children: (
          <>
            {/* <TaskEdit
                            // session={session}
                            onCancel={() => {
                                closeAllModals();
                            }}
                            // onTaskSave={() => onTaskSave()}
                            onTaskSave={() => logger.log('here')}
                            user={user}
                            mode={ViewModes.ADD}
                        /> */}
          </>
        ),
        // onClose: closeGuideModal,
      });
    }

    // switch (type) {
    //     case CaptureEventType.CREATE_TASK: {
    //         // check to make sure all captures have psdLoaded.

    //         // open the task modal
    //         // openModal({
    //         //     title: 'Create Task',
    //         //     size: 'xl',
    //         //     children: (
    //         //         <>
    //         //             <TaskEdit
    //         //                 session={session}
    //         //                 onCancel={() => {
    //         //                     closeAllModals();
    //         //                 }}
    //         //                 // onTaskSave={() => onTaskSave()}
    //         //                 onTaskSave={() => logger.log('here')}
    //         //                 user={user}
    //         //                 mode={ViewModes.ADD}
    //         //             />
    //         //         </>
    //         //     ),
    //         //     // onClose: closeGuideModal,
    //         // });
    //         const styleId = val && val.length ? val[0].styles : '';
    //         const sample = session.samples.find((item) => item.stylenumber === styleId);

    //         var psdCount = 0;
    //         let task = new TaskModel();
    //         task.deadline = session.deadline;
    //         task.type = TreatmentTypes.RETOUCHING.value;
    //         task.style = styleId;
    //         task.photoCode = sample && sample.photoCode ? sample.photoCode : '';
    //         task.user = `${user.first} ${user.last}`;
    //         task.taskPart = `Session#${session.code}`;
    //         task.items = val.map((shot, idx) => {
    //             // const { actionSort, actionPart } = shot.capture;
    //             logger.log(shot);
    //             let item = new TaskItemModel({ ...shot, productionThumb: shot.previewLo, productionPreview: shot.previewHi, referenceThumb: '', sequence: idx });

    //             // count the number of pdfs loaded
    //             if (shot.psdLoaded === 'Y') psdCount++;

    //             return item;
    //             // return { actionPart, actionSort };
    //         });
    //         task.guideId = '';
    //         task.categoryId = '';

    //         // const selectedTask = new TaskItemModel(task);

    //         // delete task.id;
    //         // delete task.user;
    //         // delete task.tags;
    //         // delete task.taskPart;
    //         // delete task.taskSort;

    //         // setCreationMap(new Map(creationMap.set(val.value, task)));
    //         // creationMap.current.set(val.value,task);

    //         // TEMP BYPASS OF CHECK UNTIL DATA IS RESOLVED
    //         psdCount = task.items.length;

    //         if (psdCount === task.items.length) {
    //             openTaskModal(task);
    //         } else {
    //             openConfirmModal({
    //                 title: 'Missing PSD Files',
    //                 centered: true,
    //                 children: <Text size='sm'>Some task items don't have associated PDFs loaded. Are you sure you wish to create a task with these items?</Text>,
    //                 labels: { confirm: 'Yes Create Task', cancel: 'No thanks' },
    //                 confirmProps: { color: 'theme' },
    //                 onCancel: () => console.log('Cancel'),
    //                 onConfirm: () => openTaskModal(task),
    //             });
    //         }

    //         break;
    //     }

    //     case CaptureEventType.IMAGE_CLICK: {
    //         // if we already have one item
    //         // if control or shift is not held we set it to a single item
    //         if (originalEvent.metaKey) {
    //             // if command held down we add the item to the array
    //             // if it's not yet selected.
    //             const obj = selectedItems.find((image) => image.id === val.id);
    //             // if the object is already selected then we unselect it
    //             if (obj) {
    //                 //items  = [...selectedItems];
    //                 items = _.remove([...selectedItems], (image) => {
    //                     return image.id !== val.id;
    //                 });
    //             } else {
    //                 items = [...selectedItems, val];
    //             }
    //         } else if (originalEvent.shiftKey) {
    //             // if shift key we push all items from the last selected item
    //             // get the index of the last element selected.
    //             let lastObj = selectedItems ? selectedItems[selectedItems.length - 1] : null;
    //             if (lastObj) {
    //                 var dataToFilter = data;
    //                 if (styleMediaFilter.groupBy && styleMediaFilter.groupBy.length) {
    //                     // dataToFilter = data.map(data => data.original);
    //                     dataToFilter = _.flatMap(data, 'subRows');
    //                 }
    //                 let lastIdx = _.findIndex(dataToFilter, function (o) {
    //                     return o.id === lastObj.id;
    //                 });
    //                 let currIdx = _.findIndex(dataToFilter, function (o) {
    //                     return o.id === val.id;
    //                 });
    //                 let newItems = [...dataToFilter.slice(lastIdx + 1, currIdx + 1)];
    //                 items = _.concat(selectedItems, newItems);
    //             }
    //         } else {
    //             items = [val];
    //             setSelectedItem({ ...val });

    //             // searchParams.set('captureId',data.captureId);
    //             // setSearchParams(searchParams);
    //         }

    //         setSelectedItems(items);

    //         break;
    //     }
    //     case CaptureEventType.IMAGE_DBL_CLICK: {
    //         // take user to captures
    //         setSelectedItem(val);
    //         // navigate(`/approval?sessionId=${data.sessionId}&captureId=${data.id}&layoutType=${ApprovalLayoutTypes.SINGLE}`);
    //         showImageModal(val);

    //         break;
    //     }

    //     default: {
    //         break;
    //     }
    // }
  };

  const setFilterVars = (vals) => {
    logger.log(vals, " FILTER VALS");
    setStyleMediaFilter(vals);
  };

  const filterButtonHandler = (e) => {
    setFilterOpen((o) => !o);
  };


  /**
   * Handler for the clear filter click.
   * Clears the media filter
   * @param {*} e
   */
  const onClearClick = (e) => {
    e.stopPropagation();
    e.nativeEvent.stopPropagation();
    // we keep the group by
    setStyleMediaFilter({
      ...new MediaFilterModel({ groupBy: styleMediaFilter.groupBy }),
    });
  };

  /**
   * Media capture menu handler
   * @param {*} e
   * @param {*} data
   */
  const onMenuClick = (e, data) => {
    // we want to store the previous nav state so we can return if we need to.
    const tmpLoc = `${location.pathname}/${location.search}`;
    setPreviousRoute(tmpLoc);

    // switch (e.type) {
    //     case CaptureEventType.SHOW_IN_CAPTURE_COMMENTS: {
    //         let client = data.sessionId && data.sessionId.length ? data.sessionId.split('-')[0] : '';
    //         navigate(`/approval?client=${client}&sessionId=${data.sessionId}&captureId=${data.id}&layoutType=${ApprovalLayoutTypes.COMMENT}`);
    //         break;
    //     }
    //     case CaptureEventType.SHOW_IN_CAPTURE: {
    //         let client = data.sessionId && data.sessionId.length ? data.sessionId.split('-')[0] : '';
    //         navigate(`/approval?client=${client}&sessionId=${session.sessionId}&layoutType=${ApprovalLayoutTypes.GRID}`);
    //         break;
    //     }
    //     case CaptureEventType.DOWNLOAD: {
    //         const extension = e.data.type && e.data.type === 'eipURL' ? 'eip' : 'png';
    //         // handleZipDownload([data], 'originalFilename', data.originalFilename, e.data.type, extension);
    //         break;
    //     }
    //     case CaptureEventType.CREATE_TASK: {
    //         onMenuItemClick(CaptureEventType.CREATE_TASK, { data: null }, [data]);
    //         break;
    //     }
    //     case CaptureEventType.APPLY_STYLE_INFO: {
    //         onMenuItemClick(CaptureEventType.APPLY_STYLE_INFO, { data: null }, [data]);
    //         break;
    //     }
    // }
  };

  const showImageModal = (data) => {
    setSelectedItem(data);
    setImageModalOpen(true);

    logger.log(data, "show modal");
  };

  const onPageChange = (idx) => {
    // gotoPage(idx);
    setSessionsPageIndex(idx);
  };

  const [showTagTalent, setShowTagTalent] = useState(false);
  const theme = useMantineTheme();
  return (
    <div style={{ height: "100%" }}>
      <Box
        px="lg"
        style={{ height: "100%", display: "flex", flexDirection: "column" }}
      >
        {/* <Group className='container-action-bar' sx={{ width: '100%' }} position='apart' height={'100%'} pt='xl' pb={'sm'} mb={'sm'}>
                    <Group>
                        <TagTalent opened={showTagTalent} onChange={setShowTagTalent} captures={selectedItems}>
                             <div>
                                <CheckboxDropdown selectedItems={selectedItems} onCheckboxClick={onSelectAll} selectMenu={selectAllMenu} />
                            </div> 
                        </TagTalent>
                        <TextInput
                            icon={<IconSearch />}
                            sx={{ width: 250 }}
                            value={styleMediaFilter?.keyword}
                            onChange={(e) =>
                                setStyleMediaFilter({
                                    ...styleMediaFilter,
                                    keyword: e.currentTarget.value,
                                })
                            }
                            placeholder={`Search across ${data.length} Media`}
                            rightSection={<ActionIcon onClick={() => setStyleMediaFilter({ ...styleMediaFilter, keyword: '' })}>{styleMediaFilter.keyword.length ? <IconX size={14} /> : null}</ActionIcon>}
                        />

                        <Text size='sm'>
                            Total{' '}
                            <strong>
                                {data.length} of {style?.assets?.length}
                            </strong>{' '}
                        </Text>
                    </Group>

                    <Group>
                        {/* <Popover shadow='sm' opened={filterOpen} onClose={() => setFilterOpen(false)} width={600} position='bottom' withArrow closeOnClickOutside={true}>
                            <Popover.Target>
                                <div>
                                    <FilterButton onClick={filterButtonHandler} onClear={onClearClick} count={filterCount} />
                                </div>
                            </Popover.Target>
                            <Popover.Dropdown>
                                <div style={{ display: 'flex' }}>
                                    <CaptureFilterPanel
                                        filter={styleMediaFilter}
                                        onCancel={() => setFilterOpen(false)}
                                        onApply={(vals) => {
                                            setFilterVars(vals);
                                            setFilterOpen(false);
                                        }}
                                        filterItems={filterItems}
                                        styleCodes={styleCodes}
                                    />
                                </div>
                            </Popover.Dropdown>
                        </Popover>

                        <Select
                            placeholder='Group By'
                            value={styleMediaFilter.groupBy}
                            onChange={(val) => {
                                setStyleMediaFilter({
                                    ...styleMediaFilter,
                                    groupBy: val,
                                });

                                // var params = Object.fromEntries([...searchParams]);
                                // params.groupBy = val;
                                // setSearchParams(params);
                            }}
                            data={[
                                { value: '', label: 'No Group' },
                                {
                                    value: 'styles',
                                    label: 'Group by Style',
                                },
                                {
                                    value: 'guideName',
                                    label: 'Group by Style Guide',
                                },
                                {
                                    value: 'machineId',
                                    label: 'Group by Machine',
                                },
                            ]}
                        />

                        <Select
              placeholder="Filter By All"
              data={[
                { value: '', label: 'Show All' },
                { value: 'sku', label: 'Filter by SKU' },
                { value: 'location', label: 'Filter by Location' },
                { value: 'status', label: 'Filter by Status' },
              ]}
            />

                        <Select
              placeholder="Sort By"
              value={sorting}
              onChange={(e) => changeSorting(e,true)}
              data={
                columns.map(val => {
                  return { value: val.accessor, label: val.Header }
                })
                }/> 

                        

                        <ListToggleControl value={listView} onChange={(val) => listToggleHandler(val)} />

                        <ListToggleControl value={listView} onChange={(val) => listToggleHandler(val)}/>
                    </Group>
                </Group> */}

        {listView === ListViewOption.LIST ? (
          <Box
            style={{
              flexGrow: 1,
              overflow: "auto",
              marginRight: -theme.spacing.xl,
            }}
            className={
              styleMediaFilter.groupBy && styleMediaFilter.groupBy.length
                ? "main-container-content show-data-grouped"
                : "main-container-content show-data-grouped-hidden"
            }
          >
            <ScrollArea
              style={(theme) => ({
                height: "100%",
                // marginRight: -theme.spacing.xl,
                paddingRight: theme.spacing.xl,
                
              })}
              onScrollPositionChange={({ y }) => setScrolled(y !== 0)}
            >
              <div
                className="h-scroll-table-container"
                style={{ height: "100%" }}
              >
                <Table
                  withRowBorders
                  withTableBorder
                  withColumnBorders
                  highlightOnHover
                  size="sm"
                  style={{ marginBottom: 10 }}
                  //   className="h-scroll-table"
                >
                  <Table.Thead
                    className={cx("scrollTableHeader", {
                      ["scrolled"]: scrolled,
                    })}
                  >
                    {table.getHeaderGroups().map((headerGroup, idx) => {
                      // const { key, ...headerProps } = { ...headerGroup.getHeaderGroupProps() };
                      return (
                        <Table.Tr
                          key={idx}
                          // {...headerProps}
                        >
                          {headerGroup.headers.map((header, i) => {
                            const { column } = header;
                            const headerWidth =
                              column.id === "expander" ? "auto" : column.width;
                            // const { key, ...colProps } = column.getHeaderProps(column.getSortByToggleProps());
                            return (
                              // Add the sorting props to control sorting. For this example
                              // we can add them into the header props
                              <Th
                                column={column}
                                onSort={() => logger.log("onsort")}
                                key={i}
                                {...{
                                  onClick:
                                    header.column.getToggleSortingHandler(),
                                  reversed:
                                    header.column.getIsSorted() === "asc"
                                      ? false
                                      : true,
                                  // onClick: header.column.getToggleGroupingHandler(),
                                  style: {
                                    cursor: "pointer",
                                    width: header.column.getIsGrouped()
                                      ? 350
                                      : "auto",
                                  },
                                }}
                                sorted={
                                  header.column.getIsSorted() ? true : undefined
                                }
                              >
                                {/* // <Th key={header.id} colSpan={header.colSpan}> */}
                                <div>
                                  {header.isPlaceholder ? null : (
                                    <div
                                      {...{
                                        className: header.column.getCanSort()
                                          ? "cursor-pointer select-none"
                                          : "",
                                      }}
                                    >
                                      {flexRender(
                                        header.column.columnDef.header,
                                        header.getContext()
                                      )}
                                    </div>
                                  )}
                                </div>
                              </Th>
                            );
                          })}
                        </Table.Tr>
                      );
                    })}
                  </Table.Thead>

                  {loading ? (
                    <Table.Tbody>
                      {[1, 2, 3, 4, 5].map((i) => (
                        <Table.Tr key={i}>
                          {columns.map((col, idx) => (
                            <Table.Td key={idx}>
                              <Skeleton height={8} my="sm" />
                            </Table.Td>
                          ))}
                        </Table.Tr>
                      ))}
                    </Table.Tbody>
                  ) : (
                    <Table.Tbody>
                      {/* {table.getRowModel().rows.map((row, idx) => {
                                            // logger.log('rowkey', key)
                                            // prepareRow(row);
                            
                                            const rowProps = {
                                              row,
                                              selectedItems,
                                              onItemClick,
                                              onMenuItemClick,
                                              onItemSelected: (evt, original, isChecked) => {
                                                onItemSelected(evt, original, isChecked, row);
                                              },
                                            //   onStatusClick,
                                            //   actionMenu,
                                            //   showPopover,
                                            //   allowAssignCapture,
                                            };
                            
                                            return <TableRow key={idx} rowId={idx} {...rowProps} />;
                                          })} */}
                    </Table.Tbody>
                  )}
                </Table>
              </div>

              {/* {!showLoading && page.length === 0 ? <EmptyState /> : null} */}
            </ScrollArea>
          </Box>
        ) : (
          <Group sx={{ height: "100%", marginLeft: -20, marginRight: -20 }}>
            <StyleMediaGridLayout
              selectedStyle={style}
              filter={styleMediaFilter}
              captures={data}
              selectedItems={selectedItems}
              selectedGroups={selectedGroups}
              onImageEvent={(type, val, originalEvent, rows) =>
                onImageEvent(type, val, originalEvent, data)
              }
              onCaptureChange={onCaptureChange}
              onGroupSelect={onItemSelected}
              showLoading={showLoading}
              showMeta={displaySettings.showMeta}
              fit={displaySettings.imageFit}
              thumbnailSize={displaySettings.imageSize}
              displaySettings={displaySettings}
              user={user}
            />
          </Group>
        )}

        {/* Footer */}
        {/* <Paper shadow='sm'>
                    <Group className={'displayFooter'}>
                        <Pagination size={'sm'} total={pageOptions.length} withEdges page={pageIndex + 1} onChange={(idx) => onPageChange(idx - 1)} /> 
                        <Group>
                            <Text size='sm'>
                                Page{' '}
                                <strong>
                                    {pageIndex + 1} of {pageOptions.length}
                                </strong>{' '}
                            </Text>

                            <NativeSelect
                                size='sm'
                                value={pageSize}
                                onChange={(e) => {
                                    setPageSize(Number(e.target.value));
                                }}
                                data={PaginationValues}></NativeSelect>
                        </Group>
                    </Group>
                </Paper> */}
      </Box>

      {/* <Modal opened={imageModalOpen} size={'lg'} title={selectedItem.originalFilename} trapFocus={true} fullScreen onClose={() => setImageModalOpen(false)}>
                <CaptureDetail image={selectedItem} src={selectedItem.previewHi} onImageEvent={() => logger.log('On image event')} onCaptureChange={onCaptureChange} />
            </Modal> */}

      {/* <pre>
        <code>
          {JSON.stringify(
            {
              selectedRowIds: selectedRowIds,
              'selectedFlatRows[].original': selectedFlatRows.map(
                d => d.original
              ),
            },
            null,
            2
          )}
        </code>
      </pre> */}
    </div>
  );
};

const mapStateToProps = (state, props) => {
  //logger.log(state,props, ' mapstate')
  return {
    user: state.auth.user,
    style: state.wipReducer.selectedStyle,
    selectedTask: state.wipReducer.selectedTask,
    displayPrefs: state.wipReducer.displayPrefs,
    styleMediaFilter: state.wipReducer.styleMediaFilter,
    success: state.wipReducer.success,
    error: state.wipReducer.error,
  };
};

const mapDispatch = { setPreviousRoute };

export default connect(mapStateToProps, mapDispatch)(StyleMediaList);

function MediaItemMenu(props) {
  return (
    <Menu size="lg" position="bottom-end">
      <Menu.Target>
        <ActionIcon>
          <IconDots />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Item
          onClick={() =>
            props.onMenuItemClick({
              type: CaptureEventType.DOWNLOAD,
              data: { type: "previewHi" },
            })
          }
          icon={<IconDownload size={14} />}
        >
          Download Hi-res
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            props.onMenuItemClick({
              type: CaptureEventType.DOWNLOAD,
              data: { type: "eipURL" },
            })
          }
          icon={<IconDownload size={14} />}
        >
          Download EIP
        </Menu.Item>
        <Menu.Item
          onClick={() =>
            props.onMenuItemClick({
              type: CaptureEventType.SHOW_IN_CAPTURE_COMMENTS,
            })
          }
          icon={<IconCamera size={14} />}
        >
          View in Captures
        </Menu.Item>
        {/* <Menu.Item onClick={() => props.onMenuItemClick({ type: CaptureEventType.CREATE_TASK })} icon={<IconSubtask size={14} />}>
                    Create Task
                </Menu.Item> */}
        <Menu.Item
          onClick={() =>
            props.onMenuItemClick({ type: CaptureEventType.APPLY_STYLE_INFO })
          }
          icon={<IconColorSwatch size={14} />}
        >
          Apply Styles
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}

const TableRow = ({
  row,
  rowId,
  selectedItems,
  onItemClick,
  onMenuItemClick,
  onStatusClick,
  onItemSelected,
  actionMenu,
  allowAssignCapture = false,
}) => {
  const theme = useMantineTheme();
  const props = {
    row,
    selectedItems,
    onItemClick,
    onMenuItemClick,
    onStatusClick,
    onItemSelected,
    actionMenu,
    allowAssignCapture,
  };
  const navigate = useNavigate();
  const { key, ...rowProps } = row.getRowProps();

  return (
    <Table.Tr
      key={rowId}
      {...rowProps}
      className={row.canExpand ? "can-expand" : ""}
    >
      {row.cells.map((cell, cellIdx) => {
        let renderCell;
        const value = cell.column.id;

        let checked = selectedItems.find((val) => val.id === row.original.id)
          ? true
          : false;

        switch (true) {
          case value.includes("expander"): {
            renderCell = (
              <Group
                sx={{
                  maxWidth: row.canExpand ? 60 : 0,
                  minWidth: row.canExpand ? 60 : 0,
                }}
              >
                {cell.render("Cell")}
              </Group>
            );
            break;
          }
          case value.includes("seasonSort"): {
            renderCell = (
              <Anchor onClick={() => onItemClick(row.original)}>
                {cell.render("Cell")}
              </Anchor>
            );
            break;
          }
          case value.includes("styleNumber"):
          case value.includes("stylenumber"): {
            renderCell = (
              <Link
                className="router-link"
                to={`/warehouse/styles/${cell.value}`}
              >
                {cell.render("Cell")}
              </Link>
            );
            break;
          }

          case value.includes("seasonCode"): {
            renderCell = (
              <Link className="router-link" to={`/seasons/${cell.value}`}>
                {cell.render("Cell")}
              </Link>
            );
            break;
          }

          case value.includes("sessionCode"): {
            renderCell = (
              <Link className="router-link" to={`/sessions/${cell.value}`}>
                {cell.render("Cell")}
              </Link>
            );
            break;
          }
          // case value.includes('photographyCount'):
          case value.includes("styleCount"): {
            renderCell = !cell.row.canExpand ? (
              <Group spacing={"xs"} sx={{ height: "100%", flexShrink: 1 }}>
                <Group wrap="nowrap" spacing={"xs"}>
                  {CountDisplay({
                    val: parseInt(row.original["sampleCount"]),
                    icon: <IconShirt size={18} strokeWidth={1} />,
                    tooltip: "Sample Acquired",
                    theme,
                    onClick: () =>
                      onStatusClick(
                        SampleStatusTypes.SAMPLE_SCAN_COUNT,
                        row.original
                      ),
                  })}
                  {CountDisplay({
                    val: row.original["photographyCount"],
                    icon: <IconCamera size={18} strokeWidth={1} />,
                    tooltip: "Photography Count",
                    onClick: () =>
                      onStatusClick(
                        SampleStatusTypes.SAMPLE_PHOTOGRAPHY_COUNT,
                        row.original
                      ),
                    theme,
                  })}
                </Group>
                <Group wrap="nowrap" spacing={"xs"}>
                  {CountDisplay({
                    val: row.original["taskCount"],
                    icon: <IconSubtask size={18} strokeWidth={1} />,
                    tooltip: "Total Tasks",
                    onClick: () =>
                      onStatusClick(
                        SampleStatusTypes.SAMPLE_TASK_COUNT,
                        row.original
                      ),
                    theme,
                  })}
                  {CountDisplay({
                    val: row.original["taskCompleteCount"],
                    icon: <IconChecklist size={18} strokeWidth={1} />,
                    tooltip: "Tasks Completed",
                    theme,
                  })}
                </Group>
              </Group>
            ) : null;
            break;
          }
          case value.includes("otbDate"):
          case value.includes("distributionDate"):
          case value.includes("completed"): {
            renderCell = (
              <Group sx={{ width: 120 }}>
                {!row.canExpand ? (
                  <Text size="sm">
                    {row.original[value] && row.original[value].length ? (
                      <Moment
                        date={row.original[value]}
                        parse="YYYY-MM-DD-hh-mm-ss"
                        format="DD/MM/YYYY"
                        trim
                      />
                    ) : (
                      ""
                    )}
                  </Text>
                ) : null}
              </Group>
            );
            break;
          }
          case value.includes("status"): {
            renderCell = (
              <div onClick={() => onItemClick(row.original)}>
                {cell.value ? (
                  <Badge color={utils.getStyleStatusColor(cell.value)}>
                    {cell.value}
                  </Badge>
                ) : null}
              </div>
            );
            break;
          }
          case value.includes('instructions["Web Photography Code"]'):
          case value.includes("photoCode"):
          case value.includes("targetSort"): {
            if (row.original.colours) {
              logger.log(rowId);
              renderCell = (
                <Group sx={{ minWidth: "130px", width: "100%" }}>
                  <Group sx={{ flexShrink: 0, flexGrow: 1 }}>
                    <Checkbox
                      checked={
                        selectedItems.find((val) => val.id === row.original.id)
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        onItemSelected(e, row.original, e.currentTarget.checked)
                      }
                    ></Checkbox>
                    {/* <SampleCheckBox  element={element} onItemSelected={(elem,selected) => selectHandler(elem,selected)} selectedItems={items} /> */}
                    {/* <Group onClick={() => onItemClick(row.original)}> */}
                    {/* <Image radius='sm' width={50} height={50} src={imgURL} /> */}
                    {/* <IconShirt /> */}
                    {/* </Group> */}
                    {/* <Box sx={{ flexShrink: 1 }} onClick={() => onItemClick(row.original)}> */}
                    <Box sx={{ flexShrink: 0, flexGrow: 1 }}>
                      {/* <SamplePopover
                          data={{ targetSort: row.original.targetSort }}> */}
                      {/* <SamplePopover key={row.original[cell.column.id]} data={{ targetSort: row.original[cell.column.id] }}> */}
                      {/* <Anchor size='sm'> */}
                      <Group position="apart">
                        <Text size="sm" lineClamp={1}>
                          {row.original[cell.column.id]}
                        </Text>

                        {row.original.liveData &&
                        row.original.liveData.files &&
                        row.original.liveData.files.length ? (
                          <Tooltip
                            position={rowId === 0 ? "bottom" : "top"}
                            label={`${moment(
                              row.original.liveData.timestamps.min
                            ).format(DataFormats.TIME_FORMAT)} → ${moment(
                              row.original.liveData.timestamps.max
                            ).format(DataFormats.TIME_FORMAT)}`}
                          >
                            {/* <PulseIndicator /> */}
                            <Box>{/* <PulseIndicator /> */}</Box>
                          </Tooltip>
                        ) : null}
                      </Group>
                      {/* </Anchor> */}
                      {/* </SamplePopover> */}

                      {/* <Text sx={{ maxWidth: 600 }} lineClamp={2} size='sm'>
                                                  {row.original.name}
                                              </Text> */}

                      {/* </SamplePopover> */}
                      {/* <Text size='xs' color='dimmed'>
                          {row.original.parentCode}
                        </Text>
                        <Text sx={{ maxWidth: 600 }} lineClamp={2} size='sm'>
                          {row.original.descr}
                        </Text> */}
                    </Box>
                  </Group>
                  {/* {row.original.showIndicator?
                                      <div style={{position:'absolute', top:0, right:0}}>
                                      <LiveIndicator />
                                      </div>
                                      :null} */}
                </Group>
              );
            } else {
              renderCell = cell.row.canExpand ? (
                <Group sx={{ minWidth: "50px" }}>
                  <Group sx={{ flexShrink: 0 }}>
                    {/* <Checkbox
                                              checked={selectedItems.find((val) => val.id === row.original.id) ? true : false}
                                              onChange={(e) => onItemSelected(e, row.original, e.currentTarget.checked)}></Checkbox> */}
                    <Group sx={{ flexShrink: 1 }}>
                      {/* {value.includes('instructions["Web Photography Code"]') ? (
                                                  <Text size='sm' lineClamp={1} sx={{ maxWidth: '350px' }}>
                                                      {row.original.instructions['Web Photography Code']}
                                                  </Text>
                                              ) : (
                                                  <Text size='sm' lineClamp={1} sx={{ maxWidth: '350px' }}>
                                                      {row.original[cell.column.id]}
                                                  </Text>
                                              )} */}
                      {row.original.id}
                      {row.original.subRows?.length ? (
                        <Badge color={"brand"}>
                          {row.original.subRows?.length}
                        </Badge>
                      ) : null}
                    </Group>
                  </Group>
                </Group>
              ) : (
                <Group sx={{ minWidth: "50px" }}>
                  <Group sx={{ flexShrink: 0 }}>
                    <Checkbox
                      checked={
                        selectedItems.find((val) => val.id === row.original.id)
                          ? true
                          : false
                      }
                      onChange={(e) =>
                        onItemSelected(e, row.original, e.currentTarget.checked)
                      }
                    ></Checkbox>
                    <Group sx={{ flexShrink: 1 }}>
                      {row.original.instructions
                        ? row.original.instructions["Web Photography Code"]
                        : ""}
                    </Group>
                  </Group>
                </Group>
              );
            }

            break;
          }
          case value.includes("descr"):
          case value.includes("description"): {
            renderCell = (
              <Text
                sx={{ maxWidth: 600, minWidth: 200 }}
                lineClamp={2}
                size="sm"
              >
                {row.original.descr}
              </Text>
            );
            break;
          }
          case value.includes('instructions["Web Stock OTB Date"]'):
          case value.includes("otbDate"): {
            renderCell = (
              <Box sx={{ maxWidth: 200, minWidth: 100 }}>
                {/* <Moment format={DataFormats.DATE_FORMAT_SHORT}>{cell.render('Cell')}</Moment> */}
                {value.includes('instructions["Web Stock OTB Date"]') ? (
                  <Moment format={DataFormats.DATE_FORMAT_SHORT}>
                    {row.original.instructions["Web Stock OTB Date"]}
                  </Moment>
                ) : (
                  cell.render("Cell")
                )}
              </Box>
            );
            break;
          }

          case value.includes("metadata_toplevelcategory"): {
            renderCell = (
              <div onClick={() => onItemClick(row.original)}>
                <Badge color="violet" sx={{ maxWidth: 150 }}>
                  {cell.render("Cell")}
                </Badge>
              </div>
            );
            break;
          }

          case value.includes("instructions"): {
            //const keys = Object.keys(row.original.instructions);
            const regex = /"(.*?)"/; // Regular expression to match the value inside double quotes

            const match = cell.column.id.match(regex);
            let key = match ? match[0] : "";
            key = key.replace(/"/g, "");

            renderCell = (
              <div
                onClick={() => onItemClick(row.original)}
                style={{ minWidth: 80 }}
              >
                {key === "department"
                  ? `${row.original.instructions["Dept"]} - `
                  : ""}
                {row.original.instructions
                  ? row.original.instructions[`${key}`]
                  : ""}

                {/* <Table striped>
                    <tbody>
                    {keys.map((key,idx) => {
                      return (<tr key={idx}>
                        <td style={{width:220}}><Text pl={'sm'} color='dimmed' mr={'md'}>{key}: </Text></td>
                        <td>{row.original.instructions[key]}</td>
                      </tr>)
                    })}
                    </tbody>
                  </Table> */}
              </div>
            );
            break;
          }

          case value.includes("issuer"): {
            const userInitials = row.original[value]
              ? utils.getUserInitials(
                  row.original[value].split(" ")[0],
                  row.original[value].split(" ")[1]
                )
              : "";
            const themeCol = utils.getUserAvatarColour(userInitials);

            renderCell = (
              <>
                {row.original[value] ? (
                  <Group wrap="nowrap">
                    <Avatar
                      variant="filled"
                      title={`${row.original[value]}`}
                      color={themeCol}
                      size={30}
                      radius={40}
                    >
                      {row.original[value].charAt(0)}
                    </Avatar>
                    <Text>{row.original[value]}</Text>
                  </Group>
                ) : null}
              </>
            );
            break;
          }

          case value.includes("action"): {
            // const menuItems = rowMenuItems?rowMenuItems:null;
            renderCell = cell.row.canExpand ? (
              <></>
            ) : (
              <Group
                sx={{
                  width: "100%",
                  alignContent: "center",
                  justifyContent: "end",
                  maxWidth: allowAssignCapture ? "auto" : "auto",
                  minWidth: allowAssignCapture ? "250px" : "auto",
                }}
              >
                {/* {actionMenu ? actionMenu : null} */}
                {allowAssignCapture && row.original.photographyCount ? (
                  <Button
                    variant="outline"
                    size="sm"
                    onClick={(e) =>
                      onMenuItemClick({
                        event: e,
                        type: SampleEventType.SAMPLE_ASSIGN_CAPTURES,
                        data: row.original,
                      })
                    }
                  >
                    Style Guide Selections
                  </Button>
                ) : null}

                {/* <SampleItemMenu
                    {...props}
                    item={row.original}
                    menuItems={actionMenu}
                  /> */}
                {/* <SampleItemMenu onMenuItemClick={(e) => onMenuClick(e,row.original)}/> */}
              </Group>
            );
            break;
          }
          case value.includes("studioSessionCodes"): {
            renderCell = (
              <Box style={{ minWidth: 140 }}>
                {row.original.studioSessionCodes?.map((val) => (
                  <div key={val}>
                    <Link to={`/sessions/${val}`} className="router-link">
                      {val}
                      {/* <Badge mb={'xs'} sx={{ cursor: 'pointer' }} onClick={(e) => onMenuItemClick({ event: e, type: SampleEventType.SAMPLE_SHOW_SESSION, data: val })}>
                                              {val}
                                          </Badge> */}
                    </Link>
                  </div>
                ))}
              </Box>
            );
            break;
          }

          case value.includes("talentCodes"): {
            renderCell = (
              <>
                <AvatarGroup spacing="sm" style={{ paddingLeft: 0 }}>
                  {row.original["talents"]?.map((talent, idx) => {
                    const userInitials = talent.fullName
                      ? utils.getUserInitials(
                          talent.fullName.split(" ")[0],
                          talent.fullName.split(" ")[1]
                        )
                      : "";
                    const themeCol = utils.getUserAvatarColour(userInitials);
                    const margin = idx ? -10 : 0;
                    return (
                      // <TalentPopover
                      //   key={idx}
                      //   data={talent}
                      //   onShowDetails={() => navigate(`/talent/${talent.code}`)}
                      // >
                      <Avatar
                        key={idx}
                        variant="gradient"
                        component={Link}
                        to={`/talent/${talent.code}`}
                        src={talent.latestURL}
                        sx={{ marginLeft: margin }}
                        title={`${talent.fullName}`}
                        color={themeCol}
                        size={25}
                        radius={40}
                      >
                        {talent.fullName?.charAt(0)}
                      </Avatar>
                      // </TalentPopover>
                    );
                  })}
                </AvatarGroup>
              </>
            );
            break;
          }

          default: {
            renderCell = cell.row.canExpand ? (
              <></>
            ) : (
              <div style={{ minWidth: 80 }}>
                <Text lineClamp={2} size="sm">
                  {cell.render("Cell")}
                </Text>
              </div>
            );
          }
        }
        const { key, ...cellProps } = cell.getCellProps();
        return (
          <Table.Td
            key={cellIdx}
            {...cellProps}
            style={{ verticalAlign: "top" }}
            className={checked ? "cellChecked" : ""}
          >
            {/* <Group sx={{minWidth:150}}> */}
            {renderCell}
            {/* </Group> */}
          </Table.Td>
        );
      })}
    </Table.Tr>
  );
};
